export default __webpack_public_path__ + "static/media/fad-waveform.157eb280.svg";